import type { ResourceProps } from "@refinedev/core";

// Solo se declaran rutas que EXISTEN en App.tsx para evitar que Refine
// auto-rutee a páginas que no están construidas y termine devolviendo al list.
export const resources: ResourceProps[] = [
  // CRUD maestros (Refine puro — Fase 4)
  { name: "tiendas",            list: "/admin/tiendas",     create: "/admin/tiendas/nueva",      edit: "/admin/tiendas/:id/editar" },
  { name: "financieras",        list: "/admin/financieras", create: "/admin/financieras/nueva",  edit: "/admin/financieras/:id/editar" },
  { name: "vendedores",         list: "/admin/vendedores",  create: "/admin/vendedores/nuevo",   edit: "/admin/vendedores/:id/editar" },
  { name: "perfiles",           list: "/admin/usuarios" },
  { name: "productos_catalogo", list: "/admin/productos",   create: "/admin/productos/nuevo",    edit: "/admin/productos/:id/editar" },
  { name: "clientes",           list: "/clientes" },

  // Híbrido (Refine list + custom create/show — Fase 5+)
  { name: "ventas",         list: "/ventas",        show: "/ventas/:id",        create: "/ventas/nueva" },
  { name: "periodos_cobro", list: "/cuentas-cobro", show: "/cuentas-cobro/:id" },
  { name: "pagos_tienda",   list: "/pagos",         create: "/pagos/nuevo" },
  { name: "anulaciones",    list: "/anulaciones",   create: "/anulaciones/nueva" },
];
